export default "__VITE_ASSET__52231d66__"